<template>
  <div :class="device" class="quantities-section-wrapper">
    <div :class="wrapperClass">
      <section class="desc">
        <h2 class="title">
          Try Workera now
        </h2>

        <div class="inv">
          Students and professionals of all-levels can use Workera to test,
          assess and progress Data - AI skills today and industry trends of
          tomorrow.
        </div>
        <div v-if="$mq === 'desktop' || $mq === 'tablet'" class="buttons-try">
          <span>
            <a class="white-button-no-border" href="/app/login/"
              >Sign up with Workera</a
            >
          </span>
          <span class="right-btn">
            <a class="white-button-no-border" href="https://workera.ai"
              >See enterprise offerings</a
            >
          </span>
        </div>
        <div v-else class="buttons-try mobile">
          <div>
            <a class="white-button-no-border" href="/app/login/"
              >Sign up with Workera</a
            >
          </div>
          <div class="bottom-btn">
            <a class="white-button-no-border" href="/for-companies/"
              >See enterprise offerings</a
            >
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
// In your Vue.js component.

export default {
  components: {},
  data() {
    return {
      hooperSettings: {
        // mobile
        itemsToShow: 1,
        breakpoints: {
          576: {
            // tablet
            itemsToShow: 2
          },
          992: {
            // laptop/desktop
            itemsToShow: 3
          }
        }
      }
    };
  },
  computed: {
    wrapperClass() {
      switch (this.$mq) {
        case "desktop":
          return "wrapper";
        case "tablet":
          return "wrapper tablet";
        default:
          return "wrapper mobile";
      }
    },
    device() {
      switch (this.$mq) {
        case "desktop":
          return "desktop";
        case "tablet":
          return "tablet";
        default:
          return "mobile";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 800;
  font-size: 36px;
  line-height: 36px;
  letter-spacing: -0.8px;
}
.buttons-try {
  font-weight: 700;
  font-size: 16px;
  line-height: 20.93px;
  letter-spacing: 0.03px;
}

%wrapper {
  background: $primary-yellow;
  display: flex;
  flex-direction: column;
  padding: 4rem 1.5rem;
}

.quantities-section-wrapper {
  @extend %wrapper;
  &.mobile {
    padding: 2rem 1.5rem;
  }
  .buttons-try {
    display: flex;
    .right-btn {
      margin-left: 0.5rem;
    }
  }

  .tablet {
    .title {
      text-align: center;
    }
    .buttons-try {
      align-items: center;
      justify-content: center;
    }
  }

  .mobile {
    .title {
      text-align: center;
      font-size: 32px;
      line-height: 32px;
      letter-spacing: -0.8px;
    }

    .buttons-try {
      margin: 0 auto;
      flex-direction: column;

      > div {
        width: 100%;
        > a {
          display: block;
          min-width: 100%;
          max-width: 100%;
        }
      }
    }
  }
}

.white-button-no-border {
  //font the same for mobile and desktop
  font-weight: 700;
  font-size: 16px;
  line-height: 20.93px;
  letter-spacing: 0.03px;
  margin-top: 0;
}

.desc {
  margin-left: 1rem;
}

.bottom-btn {
  margin-top: 2rem;
}

.inv {
  color: transparent;
  max-height: 0.9rem;
}
</style>

<style lang="scss"></style>
